(function () {
    'use strict';
    angular.module('app').controller('deletedoc', deletedoc);
    deletedoc.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'selectionCommandService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'zcs', 'ddService', 'approvalAuthService'];
    function deletedoc($location, scope, $rootScope, gridDataService, $q, selectionCommandService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, zcs, ddService, approvalAuthService) {
       
        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        scope.ACN_DELETE = 105;
        scope.xyz = { bReadyForOK: false, processing: false};
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        //
        // Enables.
        //
        scope.doEnables = function () {
            // Handle enabling OK.
            scope.xyz.bReadyForOK = true;
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {
            // Do Enables.
            scope.doEnables();
        };

        
        // On click of the command.
        scope.onDeleteDocButtonClicked = function (slx) {
            // Ping ACS. On failure, close dialog.
            zcs.Ping(true).then(function (response) {
                // List.
                scope.slx = slx;

                // Dialog config.
                scope.heading = loginService.resourceStrings["DELETE"]; // "Delete";
                if (scope.slx.list.length <= 1) {
                    scope.filesLabel = loginService.resourceStrings["DELETE_FILE"];
                }
                else {
                    scope.filesLabel = loginService.resourceStrings["DELETE_FILES"]; // "Files to Delete:";
                    //scope.filesLabel = scope.filesLabel.replace('{0}', '' + scope.slx.list.length);
                }
                scope.OK = loginService.resourceStrings["OK"]; // "OK";
                scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";

                // Dialog config columns.
                scope.gridOptions.columnDefs = [
                    { name: 'Name', field: 'name', width: '30%', minWidth: '100' },
                    { name: 'Library', field: 'library', width: '20%', minWidth: '100' },
                    { name: 'Version', field: 'version', width: '10%', minWidth: '100' },
                    { name: 'Status', field: 'status', width: '10%', minWidth: '100' }//,
                    //{ name: 'Delete File', field: 'library', width: '10%', minWidth: '100' }
                ];
                var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
                var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
                var colVersion = loginService.resourceStrings["SCHEMA_S_VERSION"];
                var colStatus = loginService.resourceStrings["SCHEMA_S_STATUS"];
                //var colDeleteFile = loginService.resourceStrings[""];
                scope.gridOptions.columnDefs[0].name = colName;
                scope.gridOptions.columnDefs[1].name = colLibrary;
                scope.gridOptions.columnDefs[2].name = colVersion;
                scope.gridOptions.columnDefs[3].name = colStatus;
                //scope.gridOptions.columnDefs[4].name = colDeleteFile;

                ///////////////////////////////////////////////////////////////////////////////////////////////////
                ///////////////////////////////////////////////////////////////////////////////////////////////////
                selectionCommandService.FilterForDelete(scope.slx).then(function (response) {
                    var slxToAddToUI = response.data;
                    scope.filesLabel = scope.filesLabel.replace('{0}', '' + slxToAddToUI.list.length);
                    // For each selection item, add a row to the grid.
                    scope.gridOptions.data = [];
                    var index = 0;
                    angular.forEach(slxToAddToUI.list, function (item) { // scope.slx.list
                        // Add item.
                        scope.gridOptions.data.push({
                            index: index,
                            selectionItem: item,
                            isSelected: true,
                            name: item.filename,
                            library: item.detailedInfo.libName,
                            version: "" + item.majRev + "." + item.minRev,
                            status: item.detailedInfo.status
                        });
                        index++;
                    });

                    // Select rows.
                    $timeout(function () {
                        refreshGrid();
                        scope.gridApi.selection.selectAllRows();
                        $timeout(function () {
                            refreshGrid();
                        }, 2000);
                    }, 500);
                }, function (response) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                }); 
              
            }, function () {
                // Handle error.
                $mdDialog.hide();
                $rootScope.msgBoxShow(loginService.resourceStrings["ACS_FAILED_TO_CONNECT"], loginService.resourceStrings["ACS_REQUIRED"]);
            });
        };

        // =====================================
        // OK, Cancel.
        // =====================================

        var deleteItem2 = function (gridItem) {
            // Must be a promise.
            var deferred = $q.defer();

            // Delete.
            //var bDeleteFileToo = true; // gridItem.selectionItem.commandParams.ebDeleteFileToo
            selectionCommandService.DeleteDocItem(
                gridItem.selectionItem.tableNumber, gridItem.selectionItem.fileId, gridItem.selectionItem.majRev, gridItem.selectionItem.minRev
                ).then(function (response) {
                    // When that  returns, ...
                    var selectionCommandResults = response.data;
                    // Walk the list and add to our results list.
                    angular.forEach(selectionCommandResults.slx.list, function (si) {
                        scope.resultSLX.list.push(si);
                    });
                    // Handle any file ops.
                    if (response != null && response.data != null && response.data.fileOperationPacket != null) {
                        // Do file op.
                        zcs.ProcessFileOperationPacket(response.data.fileOperationPacket, true).then(function (response) {
                            deferred.resolve();
                        }, function (response) {
                            selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                        }); // Do staging.
                    } else {
                        deferred.resolve();
                    };
                }, function (response) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                });// Pre Check-in

            return deferred.promise;
        }

        // Do the work of one item.
        var deleteItem = function (gridItem) {
            // Must be a promise.
            var deferred = $q.defer();

            var O_DUP = 70; // 'F'; // OPFLAG.O_DUP
            var O_NEW = 81; // 'Q'; // OPFLAG.O_NEW
            var O_OUT = 83; // 'S'; // OPFLAG.O_OUT
            var opFlag = gridItem.selectionItem.detailedInfo.opFlag;
            if (opFlag == O_DUP || opFlag == O_NEW || opFlag == O_OUT) {
                selectionCommandService.GetAccessPath(gridItem.selectionItem.tableNumber, gridItem.selectionItem.fileId, gridItem.selectionItem.majRev, gridItem.selectionItem.minRev).then(function (data) {
                    var filePNE = data.accessPNE;
                    zcs.TestAccess(filePNE, true).then(function (response) {
                        var bOK = response;
                        if (!bOK) {
                            var ec = 82; // ErrorCodes.ErrorCode.ECFILEBUSY
                            selectionCommandService.ErrorCode(gridItem.selectionItem, ec).then(function (response) {
                                scope.resultSLX.list.push(response.data);
                                deferred.resolve();
                            }, function (response) {
                                selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                            });
                        }
                        else {
                            deleteItem2(gridItem).then(function () {
                                // When it is done, we are done.
                                deferred.resolve();
                            }, function () {
                                deferred.resolve(); // Called function will not reject.
                            });
                        }
                    }, function () {
                        selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                    });
                }, function (respones) {
                    selectionCommandService.ExToErr(gridItem.selectionItem, scope.resultSLX, response); deferred.resolve();
                });
            }
            else {
                deleteItem2(gridItem).then(function () {
                    // When it is done, we are done.
                    deferred.resolve();
                }, function () {
                    deferred.resolve(); // Called function will not reject.
                });
            }

            return deferred.promise;
        }

        //// Call back from the dialog.
        //var questionBox_PostCloseCallback_LoseChangesOnHold = function (param1, param2, result) {
        //    // Remember for next time.
        //    scope.answers.loseChangesOnHold = result;
        //    var gridItem = param1;
        //    var deferred = param2;
        //    // If we are to process the item, ...
        //    if (result == 'Y' || result == 'YtoAll') {
        //        // Do the work now.
        //        deleteItem(gridItem).then(function () {
        //            // When that is done, we are done.
        //            deferred.resolve();
        //        }, function () {
        //            deferred.reject();
        //        });
        //    }
        //    else { // Or if we are not process it, ...
        //        // Then we are done.
        //        deferred.resolve();
        //    }
        //}

        // Do one item.
        var doOne = function (list, workNumber) {
            // Each item must be a promise.
            var deferred = $q.defer();
            // Get the item from the grid.
            var gridItem = list[workNumber];

            scope.processingLabel = loginService.resourceStrings["PROCESSING"] + " " + loginService.resourceStrings["FILENAME"] + ": " + gridItem.selectionItem.filename;

            //// Check for UndoCheckOut then check file change and data card change.
            //var O_HOLD = 73; // 'I'; // OPFLAG.O_HOLD
            //var bContinue = true;
            //if (gridItem.selectionItem.detailedInfo.opFlag == O_HOLD) {
            //    // If YtoAll, then fall through to checkInItem.
            //    if (scope.answers.loseChangesOnHold != 'YtoAll') {
            //        if (scope.answers.loseChangesOnHold == 'NtoAll') {
            //            deferred.resolve();
            //            return deferred.promise;
            //        }
            //        // Ask 'Are you sure?' with Y/N/YtoAll/NtoAll
            //        $rootScope.questionBoxShow(gridItem, deferred, gridItem.selectionItem.filename,
            //            loginService.resourceStrings["LOSE_CHANGES_ON_HOLD"], // "There is a WIP version of this document. This command will remove this version and all changes made to the version copy will be lost!",
            //            loginService.resourceStrings["DO_YOU_WANT_TO_CONTINUE"], // "Do you want to Continue?",
            //            questionBox_PostCloseCallback_LoseChangesOnHold)
            //        return deferred.promise;
            //    }
            //}

            // We didn't have to call something that would do the work, 
            // so we have to do it now.
            deleteItem(gridItem).then(function () {
                // When it is done, we are done.
                deferred.resolve();
            }, function () {
                deferred.resolve(); // Called function will not reject.
            });

            // Return the promise for doing the work.
            return deferred.promise;
        }

        // Walk through each item in the grid.
        var doLoop = function (list, workNumber) {
            // Each item must be a promise.
            var deferred = $q.defer();

            // Do one item.
            doOne(list, workNumber).then(function () {
                // When that is done, ...
                // Incement the item number that we are going to work on.
                workNumber++;
                // If we are still in the list, ...
                if (workNumber < list.length) {
                    // Recurse on the next item.
                    doLoop(list, workNumber).then(function () {
                        // When that is done. Resolve the promise from before.
                        deferred.resolve();
                    }, function () {
                        deferred.resolve(); // Called function will not reject.
                    });
                }
                else { // We are done with the list.
                    // Resolve this item.
                    deferred.resolve();
                    // Return the promise.
                    return deferred.promise;
                }
            }, function () {
                deferred.resolve(); // Called function will not reject.
            });

            // Return the promise for the current item.
            return deferred.promise;
        }


        //scope.onDeleteDocDialogOK = function () 
        scope.DoOK = function() {

            approvalAuthService.handleApprovalAuth(scope.slx).then(function(resp) {

                if (resp == 'cancel') {
                    return;
                }
                // Start working.
                scope.xyz.processing = true;
                scope.answers = {};
                scope.answers.loseChangesOnHold = 'N';
                scope.resultSLX = { mode: 0, order: 0, list: [] };
                scope.resultEmails = []
                // Start the loop.
                var workNumber = 0;
                doLoop(scope.gridOptions.data, workNumber).then(function () {
                    // Handle errors.
                    var slx = scope.resultSLX;
                    var atLeastOneError = false;
                    angular.forEach(slx.list, function (item) {
                        if (atLeastOneError == false) {
                            if (item.ec != 0) {
                                atLeastOneError = true;
                                if (atLeastOneError) {
                                    commandService.launchErrors({ slx: slx });
                                    //$rootScope.$broadcast('showErrorList', { slx: response.data });
                                }
                            }
                        }
                    });

                    // Close the dialog when finished.
                    $mdDialog.hide();

                    // Done.
                    scope.xyz.processing = false;
                    //gridDataService.updateGridRecords(slx.list);
                    //editEmailsService.showEditEmailsDialog(scope.resultEmails);

                    // Paul.Ligowski 2019-06-28 After delete, don't try to refresh individual rows in the DD.
                    // DefectId: 26865 - DefectName: nAWC-Delete multiple WIP versions at once brings up Object Error
                    ddService.close(); // just clears info

                    // Paul.Ligowski ABC OUT from ABC IN. Creates ABC IN which is the update, and XYZ DUP which isn't anywhere.
                    // So, don't update. Instead, reload.
                    gridDataService.updateGridRecords(slx.list); // Do both. Ex. Delete a Rev from the DD Version's Tab
                    //gridDataService.reloadGrid();
                    //ddService.refreshGrid();

                }, function () {
                    scope.xyz.processing = false;
                });
            });
            
        };


        // Call back from the dialog.
        var confirmBox_PostCloseCallback_AreYouSure = function (param1, param2, bResult) {
            if (bResult)
                scope.DoOK();
            else
                $mdDialog.hide();
        }

        scope.onDeleteDocDialogOK = function () {
            var title = loginService.resourceStrings["DELETE_CONFIRM_TITLE"];
            var msg = loginService.resourceStrings["DELETE_CONFIRM_MSG1"];
            var msg2 = loginService.resourceStrings["DELETE_CONFIRM_MSG2"];
            // Ask 'Are you sure?' with Y/N/YtoAll/NtoAll
            $rootScope.confirmBoxShow(
                null, null,
                title,
                msg, 
                msg2,
                confirmBox_PostCloseCallback_AreYouSure)
        }
   
        scope.onDeleteDocDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        // =====================================
        // Grid.
        // =====================================

        // Called after all rows are selected.
        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        // Called after the grid has been initialized.
        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            scope.onDeleteDocButtonClicked(records);
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

    }
})();
